export default __webpack_public_path__ + "static/media/Upload=Success.cadb5b06.svg";